<template>
    <div class="container spmManageDetail">
        <el-form :model="createParams" ref="createParams" label-width="140px" disabled>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('spm.trak')" prop="serialNo">
                        <!--评分任务编号-->
                        <el-input v-model.trim="createParams.serialNo" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <!-- <el-form-item label="SSR编号" prop="ssrNo" v-if="createParams.type=='SSR'">
                        <el-input v-model.trim="createParams.ssrNo" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="RFP编号" prop="rfpNo" v-else>
                        <el-input v-model.trim="createParams.rfpNo" clearable></el-input>
                    </el-form-item> -->
                    <el-form-item :label="$t('spm.ssrNo')" prop="ssrNo">
                        <el-input v-model.trim="createParams.ssrNo" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('spm.rfpNo')" prop="rfpNo">
                        <el-input v-model.trim="createParams.rfpNo" clearable></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Category1">
                        <el-input v-model.trim="createParams.catagory1Name" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Category2">
                        <el-input v-model.trim="createParams.category2Name" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('spm.creator')">
                        <el-input v-model.trim="createParams.creator" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('spm.createDate')">
                        <el-input :value="createParams.createDate | dateFormatFilter('YYYY-MM-DD')"
                                  clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('spm.finishDate')">
                        <el-input v-model.trim="createParams.finishDate" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-show="emplFlag != 'SUP'">
                    <el-form-item :label="$t('spm.ApprovalComments')"><!-- 审批意见 -->
                        <el-input v-model.trim="createParams.auditRemark" clearable></el-input>
                    </el-form-item>
                </el-col>
                <!--待供应商评分时展示倒计时天-->
                <el-col :span="8">
                    <el-form-item :label="$t('spm.day')">
                        <span>{{day}}天</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div v-if="createParams.isCreator && createParams.status=='SCORED' && createParams.shareFlag != 'Y'">
            <el-button type="primary" @click="shareMark" >{{$t('spm.pushScore')}}</el-button>
        </div>
        <div class="tableFrame">
            <div ref="tableFrameHead" class="tableFrameHead" @scroll="headHandleScroll()">
                <ul :key="index" v-for="(item,index) in bigCategoryDtos" :style="{width: computWidth+'px'}">
                    <template v-if="index==0">
                        <li style="width: 40px;" class="bigType">{{index+1}})</li>
                        <li style="width: 200px;" class="bigType" :title="item.bigName">{{item.bigName}}</li>
                        <li style="width: 500px;" class="bigType"></li>
                        <li style="width: 80px;" class="bigType">{{item.score}}</li><!-- 大类的分值 -->
                        <li :style="{width: supplierNameWidth+'px'}" class="bigType"
                            :key="sIndex"
                            v-for="(supplier,sIndex) in suppliers"
                            :title="supplier.supplierName">
                    <span v-if="index==0">
                        {{supplier.supplierName}}
                    </span>
                        </li>
                        <ul v-if="index==0">
                            <li style="width: 40px;"></li>
                            <li style="width: 200px;"></li>
                            <li style="width: 500px;"></li>
                            <li style="width: 80px;">目标分值</li>
                            <span :key="sIndex" v-for="(supplier,sIndex) in suppliers"
                                  style="width:400px;border-top: #ccc 1px solid;">
                        <li v-if="createParams.needSupplierSelfMark == 'Y'"
                            :style="{width: (createParams.needSupplierSelfMark == 'Y'&& createParams.status!='SUPSUBMIT' && emplFlag!='SS')?'270px':'70px',fontSize:'12px',paddingRight:0}">供应商自评</li>
                        <li v-if="emplFlag == 'SS' || createParams.shareFlag == 'Y'"
                            :style="{width: (emplFlag == 'SS') && createParams.status!='TO_VP_APPROVE'?'270px':'70px',fontSize:'12px',paddingLeft:0,paddingRight:0}">SS评分</li>
                        <li v-if="isSSDirector && createParams.ttSsrRoundId == null"
                            style="width: 110px;font-size: 12px;padding-left:0 ">SS SD复核</li>
                                <!-- <li>Andy复核</li>-->
                    </span>
                        </ul>
                    </template>
                </ul>
            </div>
            <div ref="tableFrameBody" class="tableFrameBody" @scroll="bodyHandleScroll()">
                <ul :key="index" v-for="(item,index) in bigCategoryDtos" :style="{width: computWidth+'px'}">
                    <!-- <span v-if="index==0">
                         <li style="width: 820px;"></li>
                         <li :style="{width: supplierNameWidth+'px'}"></li>
                     </span>-->
                    <span v-if="index!=0">
                        <li style="width: 40px;" class="bigType">{{index+1}})</li>
                        <li style="width: 200px;" class="bigType" :title="item.bigName">{{item.bigName}}</li>
                        <li style="width: 500px;" class="bigType"></li>
                        <li style="width: 80px;" class="bigType">{{item.score}}</li><!-- 大类的分值 -->
                        <li :style="{width: supplierNameWidth+'px'}" class="bigType"
                            :key="sIndex"
                            v-for="(supplier,sIndex) in suppliers"
                            :title="supplier.supplierName">
                        <span v-if="false">
                            {{supplier.supplierName}}
                        </span>
                        </li>
                    </span>
                    <ul v-if="false">
                        <li style="width: 40px;"></li>
                        <li style="width: 200px;"></li>
                        <li style="width: 500px;"></li>
                        <li style="width: 80px;">评分项分值</li>
                        <span :key="sIndex" v-for="(supplier,sIndex) in suppliers"
                              style="width:400px;border-top: #ccc 1px solid;">
                        <li v-if="createParams.needSupplierSelfMark == 'Y'"
                            :style="{width: (createParams.needSupplierSelfMark == 'Y'&& createParams.status!='SUPSUBMIT' && emplFlag!='SS')?'270px':'70px',fontSize:'12px',paddingRight:0}">供应商自评</li>
                        <li v-if="emplFlag == 'SS' || createParams.shareFlag == 'Y'"
                            :style="{width: (emplFlag == 'SS') && createParams.status!='TO_VP_APPROVE'?'270px':'70px',fontSize:'12px',paddingLeft:0,paddingRight:0}">SS评分</li>
                        <!-- <li v-if="emplFlag == 'SS' || createParams.shareFlag == 'Y'"
                            :style="{width: (emplFlag == 'SS') && createParams.status!='TO_VP_APPROVE'?'270px':'70px',fontSize:'12px',paddingLeft:0,paddingRight:0}">SS评分</li>     -->
                        <li v-if="isSSDirector "
                            style="width: 110px;font-size: 12px;padding-left:0 ">SS SD复核</li>
                            <!-- <li>Andy复核</li>-->
                    </span>
                    </ul>
                    <ul :key="index1" v-for="(small,index1) in item.smallItemDtos">
                        <li style="width: 40px;"></li>
                        <li style="width: 200px;" :title="small.smallName">{{small.smallName}}</li>
                        <li style="width: 500px;" :title="small.remark">{{small.remark}}</li>
                        <li style="width: 80px;">{{small.smallScore}}</li>
                        <li :key="sIndex" v-for="(score,sIndex) in small.scoreDataDtos">
                            <template>
                                <div style="display: inline-block;"
                                     v-if="createParams.needSupplierSelfMark == 'Y'">
                                    <template>
                                        <!-- 供应商自评后提交SS createParams.status = 'SUPSUBMIT'，页面不展示Comments列，有填写Comments的供应商细项分数旁增加图标，鼠标悬浮时展示 -->
                                        <el-tooltip class="item" effect="dark"
                                                    v-if='small.scoreDataDtosup[sIndex].remarks[small.aa] &&(createParams.status=="SUPSUBMIT" || emplFlag == "SS") '
                                                    :content="small.scoreDataDtosup[sIndex].remarks[small.aa]"
                                                    placement="right">
                                            <el-badge is-dot class="item">
                                                <el-input v-if="createParams.needSupplierSelfMark == 'Y'"
                                                      v-model="small.scoreDataDtosup[sIndex].scores[small.aa]"
                                                      type='number'
                                                      style="width: 70px;vertical-align: top;"
                                                      :disabled="emplFlag == 'SS'"></el-input>
                                            </el-badge>
                                            

                                        </el-tooltip>
                                        <template v-else>
                                            <el-input v-if="createParams.needSupplierSelfMark == 'Y'"
                                                      v-model="small.scoreDataDtosup[sIndex].scores[small.aa]"
                                                      type='number'
                                                      style="width: 70px;vertical-align: top;"
                                                      :disabled="emplFlag == 'SS'"></el-input>
                                        </template>
                                    </template>
                                    <el-input
                                            v-if="createParams.needSupplierSelfMark == 'Y'&& createParams.status!='SUPSUBMIT' && emplFlag!='SS'"
                                            :disabled="emplFlag == 'SS'"
                                            v-model="small.scoreDataDtosup[sIndex].remarks[small.aa]"
                                            placeholder="备注"
                                            style="width:200px;vertical-align: top;" type="textarea" autosize
                                            maxlength="1000"></el-input>
                                </div>


                                <!-- <el-input v-model="small.scoreDataDtosup[sIndex].scores[small.aa]" type='number'
                                      style="width: 70px;" v-if="createParams.needSupplierSelfMark == 'Y'"
                                      :disabled="emplFlag == 'SS'"></el-input>
                                <el-input v-model="small.scoreDataDtosup[sIndex].remarks[small.aa]" placeholder="备注"
                                        style="width:90px;" v-if="createParams.needSupplierSelfMark == 'Y'"
                                        :disabled="emplFlag == 'SS'"></el-input> -->
                            </template>
                            <template>
                                <template>
                                    <!-- SS评分提交评分后页面不展示Comments列，有填写Comments的SS评分细项分数旁增加图标，鼠标悬浮时展示 -->
                                    <!-- 被修改的评分细项在审批通过前高亮展示 -->
                                    <el-tooltip class="item" effect="dark"
                                                v-if='small.scoreDataDtos[sIndex].remarks[small.aa] && createParams.status=="TO_VP_APPROVE"'
                                                :content="small.scoreDataDtos[sIndex].remarks[small.aa]"
                                                placement="right">
                                        <el-badge is-dot class="item">
                                                <el-input v-if="emplFlag == 'SS' || createParams.shareFlag == 'Y'"
                                                  type='number'
                                                  :disabled="disSS"
                                                  :class="{highlightClass:small.scoreDataDtos[sIndex].Highlight[small.aa]=='Y' && SpmScmVpApprove}"
                                                  v-model="small.scoreDataDtos[sIndex].scores[small.aa]"
                                                  style="width: 70px;vertical-align: top;"></el-input>
                                        </el-badge>
                                        
                                    </el-tooltip>
                                    <template v-else>
                                        <el-input v-if="emplFlag == 'SS' || createParams.shareFlag == 'Y'"
                                                  type="number"
                                                  :disabled="disSS"
                                                  :class="{highlightClass:small.scoreDataDtos[sIndex].Highlight[small.aa]=='Y' && SpmScmVpApprove}"
                                                  v-model="small.scoreDataDtos[sIndex].scores[small.aa]"
                                                  style="width: 70px;vertical-align: top;"></el-input>
                                    </template>
                                </template>
                                <el-input v-if="(emplFlag == 'SS') && createParams.status!='TO_VP_APPROVE'"
                                          v-model="small.scoreDataDtos[sIndex].remarks[small.aa]" placeholder="备注" :disabled="disSS"
                                          style="width:200px;vertical-align: top;" type="textarea" autosize
                                          maxlength="1000"></el-input>
                            </template>
                            <div v-if="isSSDirector && createParams.ttSsrRoundId == null"
                                 style="width: 110px;display: inline-block;">
                                <!--  <template>-->
                                <el-input
                                        :style="{background:(small.scoreDataDtovp[sIndex].Highlight[small.aa]=='Y'?'red':'')}"
                                        v-model="small.scoreDataDtovp[sIndex].scores[small.aa]"
                                        type="number"
                                        placeholder="andy"
                                        class="andy" :disabled="disSSDirector"
                                        style="width: 70px;vertical-align: top;"></el-input>
                            </div>
                        </li>
                    </ul>
                </ul>
                <ul :style="{width: computWidth+'px'}">
                    <li style="width: 40px;"></li>
                    <li style="width: 200px;"></li>
                    <li style="width: 500px;"></li>
                    <li style="width: 80px;">Total:</li>
                    <li :key="index" v-for="(item,index) in countScore" :style="{width: supplierNameWidth+'px'}">
                        <el-input v-if="createParams.needSupplierSelfMark == 'Y'" v-model="item.selfMark" disabled
                                  style="width: 70px;"></el-input>
                        <el-input v-if="emplFlag == 'SS' || createParams.shareFlag == 'Y'" v-model="item.ssMark"
                                  disabled
                                  style="width: 70px;"></el-input>
                    </li>
                </ul>
            </div>
        </div>
        <!--底部操作按钮 选取文件>-->
        <!-- <el-row v-if="emplFlag == 'SS'" style="padding: 10px 0;">
            <el-col :span="2">{{$t('spm.attachmentUpload')}}</el-col>
            <el-col :span="5">
                <el-upload style="float:left"
                           ref="upload"
                           action="upload"
                           :http-request="uploadConfirm"
                           :show-file-list="false"
                           multiple
                           :disabled="!id"
                           name="file">
                    <el-button :disabled="!id" slot="trigger" size="small" type="primary">
                        {{$t('common.selectFile')}}
                    </el-button>
                </el-upload>
            </el-col>
        </el-row> -->
        <div v-if="emplFlag == 'SS'">
            <div :key="index"
                 v-for="(item,index) in fileList" style="padding-bottom: 5px;">
                <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
                <el-button type="primary" size="mini" style="margin-left: 20px;"
                           @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList)">
                    {{$t('common.del')}}
                </el-button><!--删除-->
            </div>
        </div>
        <el-row type="flex" justify="center" style="padding-top: 15px;">
            <el-button v-show="createParams.canSubmit" v-acl="SaveOrUpdateMark" type="primary" @click="save('save')">
                {{$t('common.saveDraft')}}
            </el-button>
            <el-button v-show="createParams.canSave" v-acl="SaveOrUpdateMark" type="primary" @click="save('submit')">
                {{createParams.status=='TO_SS_UPDATE'?$t('spm.ConfirmRelease'):$t('spm.SaveOrUpdateMark')}}
                <!-- 确认并发布//提交 -->
            </el-button>
            <el-button v-show="createParams.canAudit" type="primary" @click="approvalFun">{{$t('spm.canAudit')}}</el-button>
            <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
            <el-button v-show="emplFlag == 'SS'" type="primary" @click="markDownload">{{$t('spm.DownloadExcel')}}
            </el-button>
            <!-- <el-button v-show="emplFlag == 'SS'" type="primary" @click="showGantt = true">{{$t('spm.ChartDownload')}}
            </el-button> -->
        </el-row>
        <el-dialog title="Chart" :visible="showGantt" @close="showGantt = false">
            <Echart :scheduleList="suppliers" :show="showGantt" :big-category-dtos="bigCategoryDtos"
                    :score-data-dtos="scoreDataDtos" :score-data-dtosup="scoreDataDtosup"
                    :is-sel="createParams.needSupplierSelfMark"></Echart>
        </el-dialog>
        <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="approvalVisible" width="400px">
            <el-form :model="approvaForm" ref="approvaForm" :rules="approvaRules" inline label-width="90px">
                <el-form-item :label="$t('storeFeedback.auditor')" prop="auditor">
                    <el-input v-model="approvaForm.auditor" disabled></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.approvalTime') " prop="approvalTime">
                    <el-input v-model="approvaForm.approvalTime" disabled></el-input>
                </el-form-item>
                <!-- <el-form-item :label="$t('common.approvalResults') " prop="auditStatus">
                    <el-radio-group v-model="approvaForm.auditStatus">
                        <el-radio label="PASS">{{$t('common.toReview')}}</el-radio>
                        <el-radio label="REJECT">{{$t('common.noPass')}}</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <!-- :rules="approvaForm.auditStatus == 'REJECT' ? approvaForm.auditRemark :[]" -->
                <el-form-item :label="$t('settlementUnit.approvalRemarks') " prop="auditRemark">
                    <el-input v-model="approvaForm.auditRemark" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                              maxlength="300" style="width:200px"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="approvalVisible = false" type="primary">{{$t('spm.Cancel')}}</el-button>
                <el-button type="primary" @click="approvalConfirm()">{{$t('spm.determine')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import IcSelect from "@/components/common/icSelect";
    import commonFunction from "@/utils/dataTableUtils";
    import {apiService} from "@/api/spm/spm-manage";
    import supplierDialog from "@/components/page/ssr-manage/supplier-dialog";
    import {Message} from "element-ui";
    import {fileService} from "@/api/common/file-utils";
    import Echart from "@/components/page/spm/spm-manage/echart";
    import Moment from "moment";
    import utils from '@/utils/commonFun';
    import commonFun from "@/utils/commonFun";

    export default {
        inject: ['reload'],
        name: "spm-manage-detail",
        components: {
            supplierDialog,
            IcSelect,
            Echart
        },
        data() {
            return {
                approvalVisible: false,
                createParams: {
                    serialNo: null,
                    ssrNo: null,
                    createBy: null,
                    creator: null,
                    catagory1Name: null,
                    category2Name: null,
                    needSupplierSelfMark: null,
                    period: null,
                    status: null,
                    canSubmit: true,
                    canSave: true,
                    canAudit: false,
                    shareFlag: null,
                  isCreator: false,
                },
                auditLog: [],//审批日志
                approvaForm: {
                    auditor: localStorage.getItem("ms_userCd"),
                    approvalTime: this.$options.filters["dateFormatFilter"](new Date()),
                    auditStatus: 'PASS',
                    auditRemark: '',
                    tmSupplierId: null,
                },
                approvaRules: {
                    // auditStatus: [
                    //     {required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur"}
                    // ],
                    // auditRemark: [
                    //     {required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur"}
                    // ],
                },
                oldBigCategoryDtos: [],
                bigCategoryDtos: [],
                suppliers: [],
                fileList: [],
                sList: [],
                scoreDataDtos: [],
                scoreDataDtosup: [],
                scoreDataDtovp: [],
                countScore: [],//存放总分
                showGantt: false,
                day: 0,
                emplFlag: '',
                IsSCMVP: '',
                computWidth: 1000,
                supplierNameWidth: 180,
                aa: 0,
                bb: '',
                isSup: false,
                SpmScmVpApprove: false,
                isSSDirector: false,//是否SS Director复核
                disSSDirector:false,//置灰 SS Director复核
                disSS:false,//置灰 SS评分
                IsRoleSS: '',
            };
        },
        filters: {
            filterBr: function (value) {
                if (value) {
                    console.log(value)
                    value = value.replace(/↵/g, '<br>')
                }
                return value
            }
        },
        created() {
            this.id = this.$route.query.id;
            if (this.id) {
                this.getById()
                this.getFiles()
            }
            const emplFlag = localStorage.getItem("ms_emplFlag");
            // this.emplFlag = 'SUP';
            //供应商用户
            if (emplFlag === 'SUP') {
                this.emplFlag = 'SUP';
            } else {
                //非供应商，就默认都SS
                this.emplFlag = 'SS';
            }
            let permission = JSON.parse(localStorage.getItem("ms_Permission"));
            for (let i = 0, len = permission.length; i < len; i++) {
                if (permission[i] == 'IsSCMVP') {
                    this.IsSCMVP = 'IsSCMVP'
                }
                if (permission[i] == 'IsRoleSS') {
                    this.IsRoleSS = 'IsRoleSS'
                }

            }
        },
        methods: {
            //查询详情
            getById() {
                apiService.getById(this.id).then(res => {
                    let that = this
                    if (res.data) {
                        if (res.data.scoreDataDtos.length > 0) {//把 备注和分数 高亮分离出来
                            res.data.scoreDataDtos.forEach((scoresAndRemarks, index) => {
                                let temp = res.data.scoreDataDtos[index].scores
                                let scores = []
                                let remarks = []
                                let Highlight = []
                                let rightArr = []
                                temp.forEach((tempValue, index) => {
                                    scores.push(tempValue.split("`")[0])
                                    rightArr.push(tempValue.split("`")[1])
                                    Highlight.push(tempValue.split("|")[1])
                                })
                                rightArr.forEach((rightArrValue, index) => {
                                    remarks.push(rightArrValue.split("|")[0])
                                })
                                res.data.scoreDataDtos[index].scores = scores
                                res.data.scoreDataDtos[index].remarks = remarks
                                res.data.scoreDataDtos[index].Highlight = Highlight

                            })

                        }
                        if (res.data.scoreDataDtosup.length > 0) {//把 备注和分数 分离出来
                            res.data.scoreDataDtosup.forEach((scoresAndRemarks, index) => {
                                let temp = res.data.scoreDataDtosup[index].scores
                                let scores = []
                                let remarks = []
                                let Highlight = []
                                let rightArr = []
                                temp.forEach((tempValue, index) => {
                                    scores.push(tempValue.split("`")[0])
                                    rightArr.push(tempValue.split("`")[1])
                                    Highlight.push(tempValue.split("|")[1])
                                })
                                rightArr.forEach((rightArrValue, index) => {
                                    remarks.push(rightArrValue.split("|")[0])
                                })
                                res.data.scoreDataDtosup[index].scores = scores
                                res.data.scoreDataDtosup[index].remarks = remarks
                                res.data.scoreDataDtosup[index].Highlight = Highlight

                            })
                        }
                        if (res.data.scoreDataDtovp.length > 0) {//把 备注和分数 分离出来
                            res.data.scoreDataDtovp.forEach((scoresAndRemarks, index) => {
                                let temp = res.data.scoreDataDtovp[index].scores
                                let scores = []
                                let remarks = []
                                let Highlight = []
                                let rightArr = []
                                temp.forEach((tempValue, index) => {
                                    scores.push(tempValue.split("`")[0])
                                    rightArr.push(tempValue.split("`")[1])
                                    Highlight.push(tempValue.split("|")[1])
                                })
                                rightArr.forEach((rightArrValue, index) => {
                                    remarks.push(rightArrValue.split("|")[0])
                                })
                                res.data.scoreDataDtovp[index].scores = scores
                                res.data.scoreDataDtovp[index].remarks = remarks
                                res.data.scoreDataDtovp[index].Highlight = Highlight
                            })
                        }

                        that.createParams = res.data.supplierMark;

                        if(res.data.supplierMark.status == 'SCORED'){
                            that.isSSDirector = true
                        }

                        if (res.data.supplierMark.status == 'TO_SS_UPDATE') {
                            that.SpmScmVpApprove = true//显示高亮
                        }
                        if ((that.IsSCMVP == 'IsSCMVP') || (that.IsRoleSS == 'IsRoleSS' && that.createParams.status == 'TO_SS_UPDATE')) {
                            that.isSSDirector = true
                        }
                        if (that.IsRoleSS == 'IsRoleSS' && that.createParams.status == 'TO_SS_UPDATE') {
                            //复核置灰
                            that.disSSDirector = true
                        }

                        // that.disSS = !that.createParams.isCreator;
                        if (!that.createParams.isCreator || ['TO_SS_SORE','TO_SS_UPDATE','TO_SUP_SORE'].indexOf(that.createParams.status) <0){
                            //ss置灰
                            that.disSS = true
                        }
                        //轮次结束倒计时:finishDate与获取当前时间now Date()做计算
                        if (that.createParams.finishDate) {
                            //考虑到ie问题，yyyy-mm-dd转成yyyy/mm/dd
                            let finishDate = Moment(that.createParams.finishDate).format("YYYY/MM/DD")
                            let newDate = Moment(new Date).format("YYYY/MM/DD")
                            that.day = (Date.parse(finishDate) - Date.parse(newDate)) / (1 * 24 * 60 * 60 * 1000);
                        }
                        //备份一个
                        that.oldBigCategoryDtos = res.data.bigCategoryDtos;
                        that.bigCategoryDtos = res.data.bigCategoryDtos;
                        that.suppliers = res.data.suppliers;
                        that.suppliers.forEach((s, index) => {
                            //赋初始值
                            that.scoreDataDtosup.push({
                                supplierName: s.supplierName,
                                ttSupplierMarkSupplierId: s.ttSupplierMarkSupplierId,
                                tmSupplierId: s.tmSupplierId,
                                bizType: "SELF_MARK",
                                scores: [],
                                remarks: [],
                                Highlight: [],
                            })
                            that.scoreDataDtos.push({
                                supplierName: s.supplierName,
                                ttSupplierMarkSupplierId: s.ttSupplierMarkSupplierId,
                                tmSupplierId: s.tmSupplierId,
                                supStatus:s.status,
                                bizType: "SS_MARK",
                                scores: [],
                                remarks: [],
                                Highlight: [],
                            })
                            that.scoreDataDtovp.push({
                                supplierName: s.supplierName,
                                ttSupplierMarkSupplierId: s.ttSupplierMarkSupplierId,
                                tmSupplierId: s.tmSupplierId,
                                supStatus:s.status,
                                bizType: "SS_DIRECTOR",
                                scores: [],
                                remarks: [],
                                Highlight: [],
                            })

                            let selfMark = null
                            let ssMark = null
                            let row = res.data.scoreDataDtosup.filter(item => item.tmSupplierId == s.tmSupplierId)
                            if (row.length > 0 && row[0].scores.length > 0) {
                                selfMark = row[0].scores.reduce((n, m) => Number(n) + Number(m));
                            }
                            let ssRow = res.data.scoreDataDtos.filter(item => item.tmSupplierId == s.tmSupplierId)
                            if (ssRow.length > 0 && ssRow[0].scores.length > 0) {
                                ssMark = ssRow[0].scores.reduce((n, m) => Number(n) + Number(m));
                            }
                            that.countScore.push({selfMark: selfMark, ssMark: ssMark})
                        })
                        if (res.data.scoreDataDtosup.length > 0) {
                            for (let s = 0; s < that.suppliers.length; s++) {
                                for (let c = 0; c < res.data.scoreDataDtosup.length; c++) {
                                    if (that.suppliers[s].tmSupplierId == res.data.scoreDataDtosup[c].tmSupplierId) {
                                        that.scoreDataDtosup[s] = res.data.scoreDataDtosup[c]
                                    }
                                }
                            }
                        }
                        if (res.data.scoreDataDtos.length > 0) {
                            for (let s = 0; s < that.suppliers.length; s++) {
                                for (let c = 0; c < res.data.scoreDataDtos.length; c++) {
                                    if (that.suppliers[s].tmSupplierId == res.data.scoreDataDtos[c].tmSupplierId) {
                                        that.scoreDataDtos[s] = res.data.scoreDataDtos[c]
                                    }
                                }
                            }
                        }
                        if (res.data.scoreDataDtovp.length > 0) {
                            for (let s = 0; s < that.suppliers.length; s++) {
                                for (let c = 0; c < res.data.scoreDataDtovp.length; c++) {
                                    if (that.suppliers[s].tmSupplierId == res.data.scoreDataDtovp[c].tmSupplierId) {
                                        that.scoreDataDtovp[s] = res.data.scoreDataDtovp[c]
                                    }
                                }
                            }
                        }
                        // 将取到的供应商分数放入每个子类里
                        for (const i of that.bigCategoryDtos) {
                            for (const j of i.smallItemDtos) {
                                //拿到总共有几个子类
                                that.$set(j, 'aa', that.aa++)
                                //只是实现了对象的深拷贝，实现了堆中值的复制
                                that.$set(j, 'scoreDataDtos', JSON.parse(JSON.stringify(that.scoreDataDtos)))
                                that.$set(j, 'scoreDataDtosup', JSON.parse(JSON.stringify(that.scoreDataDtosup)))
                                that.$set(j, 'scoreDataDtovp', JSON.parse(JSON.stringify(that.scoreDataDtovp)))

                            }
                        }
                        //根据供应商人数计算width
                        let computWidth = null
                        let supplierNameWidth = 0
                        if (that.createParams.needSupplierSelfMark == 'Y') {
                            if (that.createParams.status != 'SUPSUBMIT' && that.emplFlag != 'SS') {
                                supplierNameWidth += 270
                            } else {
                                supplierNameWidth += 78
                            }
                        }
                        if (that.emplFlag == 'SS' || that.createParams.shareFlag == 'Y') {
                            if (that.createParams.status != 'TO_VP_APPROVE') {
                                supplierNameWidth += 270
                            } else {
                                supplierNameWidth += 78
                            }
                        }
                        if (that.isSSDirector && that.createParams.ttSsrRoundId == null) {
                            supplierNameWidth += 118
                        }
                        computWidth = that.suppliers.length * supplierNameWidth
                        that.computWidth = that.computWidth + computWidth
                        that.supplierNameWidth = supplierNameWidth-16
                    }
                });
            },
            //保存
            save(type, approvalflag) {
                let that = this

                function sum(arr) {
                    return eval(arr.join("+"));
                };
                // 将每个大类中的子列拧出来
                let scoreDataDtos = []
                let smallItemDtos = []
                let scoreDataDtovp = []
                for (const i of this.bigCategoryDtos) {
                    for (const d of i.smallItemDtos) {
                        smallItemDtos.push(d)
                    }
                }
                //讲子类里的所有的分数、拧出来，并校验必填  备注,高亮取出来
                let c = []
                let remarksArr = []
                let HighlightArr = []
                let dtoVp = []
                let vpRemarksArr = []
                let vpHighlightArr = []
                for (const d of smallItemDtos) {
                    let r = []
                    let remarksTemp = []
                    let HighlightTemp = []
                    let vp = []
                    let vpRemarksTemp = []
                    let vpHighlightTemp = []
                    if (this.emplFlag == 'SUP' && this.createParams.needSupplierSelfMark == 'Y') {
                        for (const a of d.scoreDataDtosup) {
                            if (commonFun.isEmpty(a.scores[d.aa]) && type == 'submit') {
                                this.$message({message: '请完成基础信息填写', type: "warning"});
                                return
                            }
                            if (utils.isNotEmpty(d.smallScore) && a.scores[d.aa] > d.smallScore) {
                                this.$message({message: '打分分值不能超过模板中维护的评分细项分值。', type: "warning"});
                                return
                            }
                            r.push(a.scores[d.aa])
                            remarksTemp.push(a.remarks[d.aa])
                            HighlightTemp.push(a.Highlight[d.aa])
                        }
                    } else {
                      if (that.IsRoleSS == 'IsRoleSS') {
                        for (const a of d.scoreDataDtos) {
                          console.log(a.scores[d.aa]);
                          if (commonFun.isEmpty(a.scores[d.aa]) && type == 'submit' && (a.supStatus == 'SUPSUBMIT' || this.createParams.needSupplierSelfMark == 'N')) {
                            this.$message({message: '请完成基础信息填写', type: "warning"});
                            return
                          }
                          if (utils.isNotEmpty(d.smallScore) && a.scores[d.aa] > d.smallScore) {
                            this.$message({message: '打分分值不能超过模板中维护的评分细项分值。', type: "warning"});
                            return
                          }
                          r.push(a.scores[d.aa]);
                          remarksTemp.push(a.remarks[d.aa]);
                          HighlightTemp.push(a.Highlight[d.aa]);
                        }
                      }
                      if (that.IsSCMVP == "IsSCMVP") {
                        for (const a of d.scoreDataDtovp) {
                          if (utils.isNotEmpty(d.smallScore) && a.scores[d.aa] > d.smallScore) {
                            this.$message({message: '打分分值不能超过模板中维护的评分细项分值。', type: "warning"});
                            return
                          }
                          vp.push(a.scores[d.aa]);
                          vpRemarksTemp.push(a.remarks[d.aa]);
                          vpHighlightTemp.push(a.Highlight[d.aa]);
                        }
                      }
                    }
                    c.push(r)
                    remarksArr.push(remarksTemp)
                    HighlightArr.push(HighlightTemp)
                    dtoVp.push(vp)
                    vpRemarksArr.push(vpRemarksTemp)
                    vpHighlightArr.push(vpHighlightTemp)
                }
                //将得到的所有子列分数，转换成列的形式，以供应商列为分组
                for (let i = 0; i < this.scoreDataDtos.length; i++) {
                    let scores = []
                    let remarks = []
                    let Highlight = []
                    let scoresVp = []
                    let vpRemarks = []
                    let vpHighlight = []
                    for (let t = 0; t < c.length; t++) {//把undfind替换成null
                        if (c[t][i]) {
                            scores.push(c[t][i])
                        } else {
                            scores.push('')
                        }
                    }
                    for (let t = 0; t < remarksArr.length; t++) {//把undfind替换成null
                        if (remarksArr[t][i]) {
                            remarks.push(remarksArr[t][i])
                        } else {
                            remarks.push('')
                        }
                    }
                    for (let t = 0; t < HighlightArr.length; t++) {//把undfind替换成null
                        if (HighlightArr[t][i]) {
                            Highlight.push(HighlightArr[t][i])
                        } else {
                            Highlight.push('')
                        }
                    }
                    for (let t = 0; t < dtoVp.length; t++) {//把undfind替换成null
                        if (dtoVp[t][i]) {
                            scoresVp.push(dtoVp[t][i])
                        } else {
                            scoresVp.push('')
                        }
                    }
                    for (let t = 0; t < vpRemarksArr.length; t++) {//把undfind替换成null
                        if (vpRemarksArr[t][i]) {
                            vpRemarks.push(vpRemarksArr[t][i])
                        } else {
                            vpRemarks.push('')
                        }
                    }
                    for (let t = 0; t < vpHighlightArr.length; t++) {//把undfind替换成null
                        if (vpHighlightArr[t][i]) {
                            vpHighlight.push(vpHighlightArr[t][i])
                        } else {
                            vpHighlight.push('')
                        }
                    }
                    //拿到每个子列的分数，判断填写的分数之和是否超过大类总数
                    // for (const big of this.bigCategoryDtos) {
                    //     let s = []
                    //     for (const small of big.smallItemDtos) {
                    //         if (scores[small.aa]) {
                    //             s.push(scores[small.aa])
                    //         }
                    //     }
                    //     if (sum(s) > big.score) {
                    //         this.$message({
                    //             message: `供应商评分分值不符合规则，请检查`,
                    //             type: "warning"
                    //         });
                    //         return
                    //     }
                    // }
                    let totolScores = scores.reduce((n, m) => Number(n) + Number(m));
                    /*if (totolScores > 100 && type == 'submit') {
                        this.$message({
                            message: `总分不能超过100`,
                            type: "warning"
                        });
                        return false
                    }*/
                    let newScoresRemarks = []
                    //把分数和备注 高亮 组成后端要的数据格式[1`备注1|Y,2`备注2|N,3`备注3|Y,4`备注4|Y]
                    for (let scoresIndex = 0, len = c.length; scoresIndex < len; scoresIndex++) {
                        let obj = scores[scoresIndex] + '`' + remarks[scoresIndex] + '|' + Highlight[scoresIndex]
                        newScoresRemarks.push(obj);
                    }
                    let newScoreDataDtovp = []
                    //把分数和备注 高亮 组成后端要的数据格式[1`备注1|Y,2`备注2|N,3`备注3|Y,4`备注4|Y]
                    for (let scoresIndex = 0, len = dtoVp.length; scoresIndex < len; scoresIndex++) {
                        // let obj = scoresVp[scoresIndex] + '`' + '|'
                        let obj = scoresVp[scoresIndex] + '`' + vpRemarks[scoresIndex] + '|' + vpHighlight[scoresIndex]
                        newScoreDataDtovp.push(obj);
                    }
                    console.log(newScoresRemarks)
                  let totalScoreSS = null;
                  if (scores.some(score => commonFun.isEmpty(score))) {
                    totalScoreSS = null;
                  } else {
                    totalScoreSS = scores.reduce((n, m) => Number(n) + Number(m));
                  }

                    scoreDataDtos.push({
                        tmSupplierId: this.scoreDataDtos[i].tmSupplierId,
                        ttSupplierMarkSupplierId: this.scoreDataDtos[i].ttSupplierMarkSupplierId,
                        bizType: this.emplFlag == 'SUP' ? 'SELF_MARK' : 'SS_MARK',
                        scores: newScoresRemarks,
                        totalScoreSS: totalScoreSS,
                    });
                    scoreDataDtovp.push({
                        tmSupplierId: this.scoreDataDtos[i].tmSupplierId,
                        ttSupplierMarkSupplierId: this.scoreDataDtos[i].ttSupplierMarkSupplierId,
                        bizType: 'SS_DIRECTOR',
                        scores: newScoreDataDtovp
                    })
                }
                /*供应商自评的保存  状态是 'TO_SUP_SORE'
                    如果是SS评分的保存  状态是'TO_SS_SORE'
                    如果是供应商自评的提交  状态是'SUPSUBMIT'
                    如果是SS评分的提交  状态是'TO_VP_APPROVE'*/
                let createParams = {...this.createParams}
                if (type == 'save') {
                    if (this.emplFlag == 'SUP') {
                        createParams.status = 'TO_SUP_SORE'
                    } else {
                        createParams.status = 'TO_SS_SORE'
                    }
                } else {
                    if (this.emplFlag == 'SUP') {
                        createParams.status = 'SUPSUBMIT'
                    } else {
                        if (createParams.status == 'TO_SS_SORE' || createParams.status == 'TO_SUP_SORE') {
                            createParams.status = 'TO_VP_APPROVE'
                        }
                        if (createParams.status == 'TO_SS_UPDATE') {
                            createParams.status = 'SCORED'
                        }

                    }
                }
                const param = {
                    bigCategoryDtos: this.bigCategoryDtos,
                    scoreDataDtos: this.emplFlag == 'SUP' ? [] : scoreDataDtos,
                    scoreDataDtosup: this.emplFlag == 'SUP' ? scoreDataDtos : [],
                    scoreDataDtovp: scoreDataDtovp,
                    supplierMark: createParams,
                    suppliers: this.suppliers
                }
                if (approvalflag == 'approval') {//点击审批
                    param.supplierMark.status = 'TO_SS_UPDATE'
                }
                console.log(param)
                let submitPre = new Promise(resolve => resolve());
                if(type == 'submit' && this.emplFlag != 'SUP'){
                    submitPre = apiService.countUnSubmitSuppliers(this.createParams.ttSupplierMarkId).then(res => {
                        if (res.data > 0) {
                            return this.confirm(`尚有${res.data}家供应商未提交评分，请确认是否提交；如提交，则对应供应商无法提交评分，如需评分需要重新创建评分任务。`);
                        } else {
                            return new Promise(resolve => resolve());
                        }
                    });
                }
                submitPre.then(() => {
                    apiService.toSubmitMark(param).then(res => {
                        if (res.code === '200') {
                            this.$message({
                                message: this.$t("common.operateSuccess"),
                                type: "success"
                            });
                            if (type == 'save') {
                                this.id = res.data.supplierMark.ttSupplierMarkId;
                                this.reload()
                                // this.getById()
                                // that.$router.replace({
                                //     name: `spm-manage-detail`,
                                //     query: {
                                //         id: this.id,
                                //         timestamp: new Date().getTime()
                                //     }
                                // })
                            } else {
                                this.$router.go(-1);
                            }
                        } else {
                            Message.error(res.msg || this.$t("common.operateError"));
                        }
                    });
                }).catch(reason => console.log(reason));
            },

            //文件列表数据获取
            getFiles: function () {
                let attachment = {};
                attachment.seq = '1';
                attachment.tsRecId = this.id;
                attachment.tsReckindId = 'SPM';
                fileService.getFileList(attachment).then((fileRes) => {
                    this.fileList = fileRes;
                })
            },
            //文件上传
            uploadConfirm: function (item) {
                let _this = this;
                let formData = new FormData();
                formData.append("file", item.file);
                fileService.fileUpload(formData).then((res) => {
                    //调用成功后调用后台方法进行文件关系维护
                    let attachment = {};
                    attachment.documents = res.data;
                    attachment.seq = '1';
                    attachment.tsRecId = this.id;
                    attachment.tsReckindId = 'SPM';
                    fileService.saveFile(attachment).then((saveRes) => {
                        _this.getFiles();
                    })
                }).catch((error) => {
                    //文件上传失败
                    Message({message: this.$t('common.fileUploadFailed'), type: "error"});
                });
            },
            //文件下载
            downloadFile: function (row) {
                fileService.downloadFile(row)
            },
            //文件删除
            deleteFile: function (tmDocumentId, index, files) {
                fileService.deleteFile(tmDocumentId).then((res) => {
                    //删除成功删除列表数据
                    files.splice(index, 1);
                })
            },
            //评分excel下载
            markDownload: function () {
                apiService.markDownload(this.id).then((res) => {
                })
            },
            //供应商评分分享
            shareMark: function () {
                let ttSupplierId = this.suppliers.map(data => data.tmSupplierId)
                apiService.shareMark({
                    supplierMark: {
                        ttSupplierMarkId: this.id,
                        supplierIds: ttSupplierId
                    }
                }).then((res) => {
                    if (res.code === '200') {
                        this.$message({
                            message: this.$t("common.operateSuccess"),
                            type: "success"
                        });
                        this.reload()
                        // this.getById()
                    } else {
                        Message.error(res.msg || this.$t("common.operateError"));
                    }
                })
            },
            //审批
            approvalFun() {
                this.approvalVisible = true
            },
            //审批
            approvalConfirm() {
                let that = this;
                this.$refs.approvaForm.validate(valid => {
                    if (valid) {
                            that.createParams.auditStatus = that.approvaForm.auditStatus,
                            that.createParams.auditRemark = that.approvaForm.auditRemark
                            that.save('submit', 'approval')
                    } else {
                        return false;
                    }
                });
                this.approvalVisible = true
            },
            historyBack: function () {
                // this.$router.go(-1);
                this.$router.push({
                    name: 'spm-manage'
                });
            },
            headHandleScroll() {
                this.$refs.tableFrameBody.scrollLeft = this.$refs.tableFrameHead.scrollLeft
            },
            bodyHandleScroll() {
                this.$refs.tableFrameHead.scrollLeft = this.$refs.tableFrameBody.scrollLeft
            }
        },
        extends: commonFunction
    };
</script>
<style scoped lang="scss">
    .el-table {
        margin-top: 10px;
    }

    .el-select {
        width: 90%;
    }

    .tableFrame {
        width: 100%;
        /*overflow-x: auto;*/

        .tableFrameHead {
            overflow-x: auto;
            overflow-x: hidden;
        }

        .tableFrameBody {
            overflow-y: auto;
            max-height: 400px;
        }
    }

    ul {
        clear: both;
        padding: 0;
        margin: 0;
    }

    ul {
        li {
            float: left;
            display: block;
            text-align: left;
            border-top: #ccc 1px solid;
            color: rgb(70, 70, 70);
            padding: 8px;
            font-size: 14px;
            white-space: pre-wrap;
        }

        .el-row {
            display: flex;
            flex-wrap: wrap;
        }
    }

</style>
<style lang="scss">
    .spmManageDetail {
        .highlightClass .el-input__inner {
            color: #f8ab01 !important;
            border-color: #f8ab01 !important;
        }

        .el-textarea__inner {
            height: 32px;
        }

        .andy .el-input__inner {
            background: none !important;
            border-radius: 1px;
        }
        .bigType{
            font-weight: bold;
            font-size: 15px;
        }
        .el-badge__content.is-fixed{
            right:6px;
        }
    }
</style>